// extracted by mini-css-extract-plugin
export default {"text":"bWzAIVV3IqDivZHscDGl"};